export const blockIconsFileFolderZip = (
	<span className='material-symbols-outlined'>folder_zip</span>
);
